var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 8C14.9688 8.5625 14.5312 9 14 9H4.40625L7.6875 12.3125C8.09375 12.6875 8.09375 13.3438 7.6875 13.7188C7.5 13.9062 7.25 14 7 14C6.71875 14 6.46875 13.9062 6.28125 13.7188L1.28125 8.71875C0.875 8.34375 0.875 7.6875 1.28125 7.3125L6.28125 2.3125C6.65625 1.90625 7.3125 1.90625 7.6875 2.3125C8.09375 2.6875 8.09375 3.34375 7.6875 3.71875L4.40625 7H14C14.5312 7 14.9688 7.46875 14.9688 8Z",
    fill: "#007FAD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljk2ODggOEMxNC45Njg4IDguNTYyNSAxNC41MzEyIDkgMTQgOUg0LjQwNjI1TDcuNjg3NSAxMi4zMTI1QzguMDkzNzUgMTIuNjg3NSA4LjA5Mzc1IDEzLjM0MzggNy42ODc1IDEzLjcxODhDNy41IDEzLjkwNjIgNy4yNSAxNCA3IDE0QzYuNzE4NzUgMTQgNi40Njg3NSAxMy45MDYyIDYuMjgxMjUgMTMuNzE4OEwxLjI4MTI1IDguNzE4NzVDMC44NzUgOC4zNDM3NSAwLjg3NSA3LjY4NzUgMS4yODEyNSA3LjMxMjVMNi4yODEyNSAyLjMxMjVDNi42NTYyNSAxLjkwNjI1IDcuMzEyNSAxLjkwNjI1IDcuNjg3NSAyLjMxMjVDOC4wOTM3NSAyLjY4NzUgOC4wOTM3NSAzLjM0Mzc1IDcuNjg3NSAzLjcxODc1TDQuNDA2MjUgN0gxNEMxNC41MzEyIDcgMTQuOTY4OCA3LjQ2ODc1IDE0Ljk2ODggOFoiIGZpbGw9IiMwMDdGQUQiLz4KPC9zdmc+Cg==";